import React from "react";

import { useWindowDimensions } from "@hooks/useWindowDimensions";
import BaseScrollLink from "@components/toolkit/BaseScrollLink/BaseScrollLink";

import "./NavbarLink.scss";

interface NavbarLinkProps {
  children: React.ReactNode;
  sectionID: string;
  offsetTopDesktop?: number;
  offsetTopMobile?: number;
  smooth?: boolean;
  duration?: number;
  onClick?: () => void;
}

export const MOBILE_BREAKPOINT = 768;

const NavbarLink = ({
  children,
  sectionID,
  offsetTopDesktop = -45,
  offsetTopMobile = 0,
  smooth = true,
  duration = 100,
  onClick
}: NavbarLinkProps) => {
  const { width } = useWindowDimensions();

  const isMobile = width <= MOBILE_BREAKPOINT;
  const offsetTop = isMobile ? offsetTopMobile : offsetTopDesktop;

  const navbarLinkClass = `navbar-link`;
  const navbarLinkActiveClass = `navbar-active-link`;

  return (
    <BaseScrollLink
      to={sectionID}
      offset={offsetTop}
      smooth={smooth}
      duration={duration}
      className={navbarLinkClass}
      activeClass={navbarLinkActiveClass}
      onClick={onClick}
      spy
    >
      {children}
    </BaseScrollLink>
  );
};

export default NavbarLink;
